import config from '../config'
import { authHeader } from './auth-header'

export const invoiceService = {
  getInvoiceById,
  createInvoice,
  getUnpostedInvoices,
  postInvoices,
  updateInvoice,
  getLocatorById,
  getVendorLocatorById,
  processRefund
}

function getInvoiceById (invoiceNumber) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/invoices/${invoiceNumber}`, requestOptions).then(handleResponse)
}

function getLocatorById (locatorNumber) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/invoices/locator/${locatorNumber}`, requestOptions).then(handleResponse)
}

function getVendorLocatorById (vendorLocatorNumber){
  const requestOptions= {
    method : 'GET', 
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/invoices/vendorlocator/${vendorLocatorNumber}` , requestOptions) . then(handleResponse)
}

function getUnpostedInvoices () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/invoices/unposted/`, requestOptions).then(handleResponse)
}


function postInvoices (invoiceIds) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify({invoiceIds: invoiceIds})
  }
  return fetch(`${config.apiUrl}/invoices/postInvoices/`, requestOptions).then(handleResponse)
}

function createInvoice (customer,invoiceData,paymentData,flightData,passengerData,supplierData,servicesData,sendSms) {
  console.log("creating invoice");
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify({customer: customer, invoice: invoiceData,payment:paymentData, flights:flightData, passengers:passengerData,supplier:supplierData,services:servicesData, sendSms: sendSms || false})
  }
  return fetch(`${config.apiUrl}/invoices/create`, requestOptions).then(handleResponse)
}

function updateInvoice (customer,invoiceData,paymentData,flightData,passengerData,supplierData,servicesData) {
  console.log("updating invoice");
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify({customer: customer, invoice: invoiceData,payment:paymentData, flights:flightData, passengers:passengerData,supplier:supplierData,services:servicesData})
  }
  return fetch(`${config.apiUrl}/invoices/update`, requestOptions).then(handleResponse)
}

function processRefund (refundData) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(refundData)
  }
  return fetch(`${config.apiUrl}/invoices/refund`, requestOptions).then(handleResponse)
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        // logout()
        // location.reload(true)
      }

      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return data.Response
  })
}
